import React, { useEffect, useState } from 'react';
import axios from '../api/axios';
import { Link } from 'react-router-dom';
import Banner from '../components/Banner';

export default function Courses() {
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    axios.get('/courses')
      .then(res => setCourses(res.data))
      .catch(() => alert('Failed to load courses'));
  }, []);
  return (
    <>
      <Banner />
      <section className="bg-gray-100 py-[36px] md:py-[72px] min-h-screen">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6 demand-course-flex">
            {courses.map((course) => (
              <div key={course.id} className="flex flex-col gap-6">
                <div className="overflow-hidden group flex flex-col h-full rounded-[16px] border border-[#d9d9d9] bg-white hover:border-red-600">

                  {/* Image */}
                  <img
                    src={course.image ?? "https://www.infosectrain.com/wp-content/uploads/2024/08/feature-default.webp"}
                    alt="InfosecTrain Trending Courses"
                    className="w-full h-auto block rounded-t-[16px]"
                    loading="lazy"
                  />

                  {/* Card Content + Button */}
                  <div className="flex flex-col justify-between flex-grow">
                    {/* Title */}
                    <p className="text-dark-600 font-bold text-sm md:text-base line-clamp-2 m-4">
                      {course.title}
                    </p>

                    {/* Button */}
                    <Link
                      to={`/courses/${course.slug}`}
                      className="mt-auto block px-6 py-3 w-full bg-grey-600 text-grey-disable text-center font-bold uppercase no-underline hover:bg-bg-gradient-orange hover:text-white group-hover:bg-bg-gradient-orange group-hover:text-white transition"
                    >
                      Click Here
                    </Link>
                  </div>
                </div>
              </div>

            ))}
          </div>
        </div>
      </section>
    </>
  )
}
